import { Vue, Component, Prop } from 'vue-property-decorator';
import SummaryPullupHeader from '@/components/pull-up/summary-pullup-header/summary-pullup-header';
import moment from 'moment';
import { reportsApi } from '@/providers/apis/reports/reports';
import { sessionService } from '@/providers/services/auth/session';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
    name: 'usage-summary-drill-down',
    components: {
        'summary-pullup-header': SummaryPullupHeader,
    },
})

export default class UsageSummaryReport extends Vue {

    public get session() {
        return sessionService.getSession();
    }
    public activeTenantId: any;

    @Prop()
    public groupHierarchies: any;

    public groupHierarchyLevels: any = [];

    public levelData: any = {
        level0 : 'Level 0 Teachers',
        level1 : 'Level 1 Teachers',
        level2 : 'Level 2 Teachers',
        level3 : 'Level 3 Teachers',
    };

    public paramsPayload: any = {
        from_year: moment().year() - 1,
        to_year: moment().format('YYYY'),
        from_month: moment().format('MM'),
        to_month: moment().format('MM'),
    };

    public reportData: any = null;

    public subjectList: any = null;

    public selectedSubject: any = null;

    private showPopover: boolean = false;

    private tierData: any = [
        {
            title : 'Level 0 Teachers',
            details : 'Teachers that have been rostered and oriented but have not started using the LN',
        },
        {
            title : 'Level 1 Teachers',
            details : 'Teachers that have used the LN for at least a month, AND taken 1 assessment',
        },
        {
            title : 'Level 2 Teachers',
            details : 'Teachers that have taken 2-10 Assessments AND used LN for 2-3 months',
        },
        {
            title : 'Level 3 Teachers',
            details : 'Teachers that have taken 10+ Assessments AND used LN for 4+ months',
        },
    ];

    public handleRangeSelection(rangeData: any) {
        this.paramsPayload = {
            ...this.paramsPayload,
            ...rangeData,
        };
        this.loadData();
    }

    public onSelectSubject(subject: any) {
        this.selectedSubject = subject;
        this.paramsPayload.subject = this.selectedSubject ? this.selectedSubject.code : '';
        if (!subject) {
            delete this.paramsPayload.subject;
        }
        this.loadData();
    }

    public onChangeFilter(type: string, drilldownData: any) {
        this.paramsPayload = {
            ...this.paramsPayload,
            group_type: type,
        };
        if (type === 'class') {
            this.paramsPayload.class_ids = drilldownData ? drilldownData.join(',') : '';
            delete this.paramsPayload.group_ids;
        } else {
            this.paramsPayload.group_ids = drilldownData ? drilldownData.join(',') : '';
            delete this.paramsPayload.class_ids;
        }
        if (!drilldownData || !drilldownData.length) {
            delete this.paramsPayload.group_type;
            delete this.paramsPayload.group_ids;
            delete this.paramsPayload.class_ids;
        }
        this.loadData();
    }

    private created() {
        const activeTenant = this.$access.getGroupHierarchyTenants;
        this.activeTenantId = JSON.parse(activeTenant).id;
        this.loadData();
        const params = {
            tenants: this.activeTenantId ? this.activeTenantId : this.session!.tenant!.tenant_id,
        };
        reportsApi.fetchSubjectList(params).then((response) => {
            this.subjectList = response;
        });
    }
    private loadData() {
        this.groupHierarchyLevels = appConfigService.getUserGroupAccessLevel() || [];
        this.paramsPayload.tenants = this.activeTenantId ? this.activeTenantId : this.session!.tenant!.tenant_id;
        if (!this.paramsPayload.group_type) {
            const groupType = this.groupHierarchyLevels[0].type;
            this.paramsPayload.group_type = groupType;
        }
        reportsApi.fetchUsageSummaryReports(this.paramsPayload).then((response) => {
            this.reportData = response;
        });
    }
}
